import React, { useState } from 'react';
import { Upload } from './Upload';
import { UnsplashSearch } from './UnsplashSearch';
interface AddCoverProps {
  cardId: string;
  navigateToSelectCover: () => void;
}

export const AddCover: React.FunctionComponent<AddCoverProps> = ({
  cardId,
  navigateToSelectCover,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const onSetCover = () => {
    navigateToSelectCover();
  };

  return (
    <>
      {!isUploading && (
        <UnsplashSearch
          cardId={cardId}
          onSetCover={onSetCover}
          onSetSearching={setIsSearching}
        />
      )}
      {!isSearching && (
        <>
          <Upload
            cardId={cardId}
            onFileSelected={() => {
              setIsUploading(true);
            }}
            onFileUploaded={() => {
              onSetCover();
            }}
            onUploadFailed={() => {
              setIsUploading(false);
            }}
          />
        </>
      )}
    </>
  );
};
